import { AntTextArea, UploadComment } from "components/Antd";
import { CommonButton, RippleEffect } from "components/UiElement";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import { validation } from "./validation";

function CommentForm({
  onSubmit,
  handleCloseModalComment,
  theme,
  subscriptionData,
}) {
  const { t } = useTranslation();
  const [coverUrl, setCoverUrl] = useState(undefined);
  let initialValues = {
    comment: "",
    filePath: "",
  };
  const ratios = {
    theme01: 1.8,
    theme02: 1,
    theme03: 2.01,
    theme04: 1.76,
  };
  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={onSubmit}
        validationSchema={validation(coverUrl)}
        enableReinitialize
      >
        {(props) => {
          return (
            <div className="commentModel_body">
              <Form>
                <div className="d-sm-flex w-100">
                  <div className="commentModel_left flex-shrink-0">
                    <h2>Upload Picture/ pdf</h2>
                    <UploadComment
                      props={props}
                      coverUrl={coverUrl}
                      setCoverUrl={setCoverUrl}
                      name="filePath"
                      filePath=""
                      aspect={ratios?.[theme]}
                      step={4}
                      subscriptionData={subscriptionData}
                      query
                    />
                  </div>

                  <div className="commentModel_right w-100">
                    <h2>Comment</h2>
                    <Row className="g-20">
                      <Col xs={12}>
                        <div className="form-group">
                          <AntTextArea
                            className="form-control form-control-textarea w-100"
                            placeholder={t("text.createMemories.typeHere")}
                            setFieldValues={props.handleChange}
                            name="comment"
                            maxLength={250}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="commentModel_btn d-flex justify-content-end">
                      <RippleEffect>
                        <CommonButton
                          className="btn btn-light"
                          onClick={() => handleCloseModalComment()}
                        >
                          Close
                        </CommonButton>
                      </RippleEffect>
                      <RippleEffect>
                        <CommonButton
                          className="btn btn-danger"
                          type="submit"
                          disabled={props?.values?.comment === ""}
                        >
                          {t("text.common.send")}
                        </CommonButton>
                      </RippleEffect>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    </>
  );
}

export default CommentForm;
